import script from "./FeedbackButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackButton.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackButton.vue?vue&type=style&index=0&id=3c09ae32&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c09ae32"]])

export default __exports__